<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <div class="vx-row pt-2">
        <vs-button size="small" class="mr-2 px-3" color="success" type="filled" icon-pack="feather" icon="icon-edit" @click="editRecord"></vs-button>
        <vs-button size="small" class="px-3" color="danger" type="filled" icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord"></vs-button>
      </div>
    </div>
</template>

<script>
export default {
  name: 'CellRendererActions',
  methods: {
    editRecord () {
      this.$router.push(`/users/edit/${this.params.data.id}`)
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Perhatian',
        text: `Anda akan menghapus "${this.params.data.username}" ?`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    deleteRecord () {
      const self = this
      this.$store.dispatch('user/deleteUser', this.params.data.id)
        .then(function () {
          self.params.getUsers()
          self.showDeleteSuccess()
        })
        .catch(err => {
          this.$vs.notify({
            color: 'danger',
            title: 'Oops..',
            text: err
          })
        })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'Berhasil',
        text: 'Perusahaan terpilih berhasil dihapus'
      })
    }
  }
}
</script>
